import {createSlice} from '@reduxjs/toolkit';

const formResultSlice = createSlice({
  name: 'expFormResult',
  initialState: {
    expFormDetails: []
  },
  reducers: {
    setFormresultList: (state, action) => {
      state.expFormDetails = action.payload.expFormDetails;
    },
  },
});
export const selectExpForm = (state) => state.expFormResult;
export const {
  setFormresultList,
} = formResultSlice.actions;

export default formResultSlice.reducer;
